module.exports = __webpack_public_path__ + "static/media/12UNCTAD9.7daf11dc.jpg";